import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate } from "react-router";

import { Card, TabMenu } from "@digital-services/ui";
import { ITabMenuTab } from "@digital-services/ui/types";

import { useTabIndex } from "@hooks/useTabIndex";
import { useUserContext } from "@hooks/useUserContext";

import { apiUsersFeatureEnabled } from "../../feature-flags";

const OrganizationTabMenu: FunctionComponent = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "organization" });

  const { user: currentUser } = useUserContext();

  const tabs: ITabMenuTab[] = [
    {
      id: "organization",
      label: t("tabs.organization"),
      content: (
        <Card className="mt-0" data-testid="organization-tab-card">
          <Outlet />
        </Card>
      )
    }
  ];

  if (currentUser.isAdministrator) {
    tabs.push({
      id: "users",
      label: t("tabs.users"),
      content: (
        <Card className="mt-0" data-testid="users-tab-card">
          <Outlet />
        </Card>
      )
    });
  }

  if (currentUser.isAdministrator && apiUsersFeatureEnabled) {
    tabs.push({
      id: "api-users",
      label: t("tabs.api-users"),
      content: (
        <Card className="mt-0" data-testid="api-users-tab-card">
          <Outlet />
        </Card>
      )
    });
  }

  const { currentTabIndex } = useTabIndex(tabs);
  const navigate = useNavigate();

  const handleChangeTab = (tabIndex: number) => {
    if (tabIndex === 0) {
      return navigate("");
    }

    navigate(tabs[tabIndex].id.toLowerCase());
  };

  return (
    <TabMenu
      value={currentTabIndex}
      onChange={handleChangeTab}
      tabs={tabs}
      isSubMenu
    />
  );
};

export default OrganizationTabMenu;
